import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { formatStateDate } from '../../utils';
import { DateFilterType, onDateChangeType } from './types';

interface UseExactDateFilterI {
  value: string | null;
  onDateChange: onDateChangeType;
}

const useExactDateFilter = (initValue: string | null): UseExactDateFilterI => {
  const dispatch = useDispatch();
  const [value, setValue] = useState<null | string>(initValue);

  const setDateFilter = (
    dateObj: DateFilterType,
    setDateAction?: (dateObj: DateFilterType) => void
  ): void => {
    if (setDateAction) {
      dispatch(setDateAction(dateObj));
    }
  };

  const onDateChange: onDateChangeType = (newValue, setDateAction) => {
    const date = formatStateDate(newValue);
    const dateObj = {
      startDate: date,
      endDate: date,
    };
    setDateFilter(dateObj, setDateAction);

    setValue(date);
  };

  return {
    value,
    onDateChange,
  };
};

export default useExactDateFilter;
